import React, { useEffect, useRef, useState } from 'react'
import AuthService from '../../../api/services/AuthService';
import { ApiConfig } from '../../../api/apiConfig/apiConfig';
import { $ } from 'react-jquery-plugin';
import { alertErrorMessage, alertSuccessMessage } from '../../../customComponents/CustomAlertMessage';
import LoaderHelper from '../../../customComponents/Loading/LoaderHelper';
import moment from 'moment';
import { usePlatformStatus } from '../../../context/PlatformStatusProvider';

import { mapCoboWithdrawalItem } from '../../../utils/coboWithdrawal';
import { filterActiveCoboChains, isCoboChainActive } from '../../../utils/coboChainList';

const WithdrawPage = (props) => {
  const { getStatus } = usePlatformStatus();
  const isWithdrawalDisabled = !getStatus('withdrawal').enabled;

  const [availableCurrency, setAvailableCurrency] = useState([]);
  const [allData, setAllData] = useState([]);
  const [searchPair, setSearchPair] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState({});
  const [recentWithdrawHistory, setRecentWithdrawHistory] = useState([]);
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [selectedNetworkInfo, setSelectedNetworkInfo] = useState(null);
  const [loadingAssetChain, setLoadingAssetChain] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [withdrawAddress, setWithdrawAddress] = useState("");
  const [availableBalance, setAvailableBalance] = useState("");
  const [fundData, setFundData] = useState([]);
  const [isValidWalletAddress, setIsValidWalletAddress] = useState(true);
  const [otp, setotp] = useState("");
  const [allCoinData, setAllCoinData] = useState([]);
  const [modalData, setModalData] = useState({});
  const [withdrawSuccessData, setWithdrawSuccessData] = useState(null);
  const fetchChainRequestRef = useRef(0);

  const getCoboDepositAssets = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCoboDepositAssets();
      if (result?.success) {
        const list = Array.isArray(result?.data) ? result.data : [];
        setAvailableCurrency(list);
        setAllData(list);
      } else if (result?.message) {
        alertErrorMessage(result.message);
      }
    } catch (error) {
      alertErrorMessage("Failed to load coins");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const allCoins = async () => {
    await AuthService.allCoins().then(async (result) => {
      if (result?.success) {
        try {
          setAllCoinData(result?.data)

        } catch (error) {

        }
      }
    });
  };

  const handleWithdrawModal = (item) => {
    function shortenAddress(address, length = 4) {
      if (!address || address.length < 10) return address;
      return `${address.slice(0, length + 2)}...${address.slice(-length)}`;
    }
    const mapped = mapCoboWithdrawalItem(item);
    const shortAddress = shortenAddress(mapped?.from_address);
    const shortToAddress = shortenAddress(mapped?.to_address);
    const shortTxHash = shortenAddress(mapped?.transaction_hash);

    setModalData({ ...mapped, shortAddress, shortTxHash, shortToAddress });

    $("#recent_table").modal('show');
  };

  const withdrawHistory = async () => {
    try {
      const result = await AuthService.getCoboWithdrawalHistory(1, 5);
      if (result?.success) {
        const list = (Array.isArray(result?.data) ? result.data : []).map(mapCoboWithdrawalItem);
        setRecentWithdrawHistory(list);
      }
    } catch (error) {
      // ignore
    }
  };

  const getLegacyChainKey = (chainId) => {
    if (!chainId) return "";
    if (chainId === "TRON") return "TRC20";
    if (chainId === "BSC_BNB" || chainId.startsWith("BSC")) return "BEP20";
    if (chainId === "MATIC") return "ERC20";
    if (chainId === "ETH" || chainId.includes("ETH")) return "ERC20";
    return chainId;
  };

  const getChainValue = (field, chainId) => {
    const val = selectedCurrency?.[field];
    if (typeof val === 'object' && val !== null) {
      const legacyKey = getLegacyChainKey(chainId);
      return val?.[chainId] ?? val?.[legacyKey];
    }
    return val;
  };

  const getCoboNetworks = () =>
    filterActiveCoboChains(selectedCurrency?.cobo_chain_list);

  const getNetworkLabel = () =>
    selectedNetworkInfo?.chainName || selectedNetwork || "Select Network";

  const parseNetworkLimit = (value) => {
    if (value == null || value === "") return null;
    const num = parseFloat(value);
    return Number.isFinite(num) ? num : null;
  };

  const getSelectedNetworkFee = () =>
    parseNetworkLimit(selectedNetworkInfo?.withdrawalFee) ??
    parseNetworkLimit(getChainValue("withdrawal_fee", selectedNetwork)) ??
    0;

  const getSelectedNetworkMinWithdrawal = () =>
    parseNetworkLimit(selectedNetworkInfo?.minWithdrawalLimit) ??
    parseNetworkLimit(getChainValue("min_withdrawal", selectedNetwork)) ??
    0;

  const getSelectedNetworkMaxWithdrawal = () =>
    parseNetworkLimit(selectedNetworkInfo?.maxWithdrawalLimit) ??
    parseNetworkLimit(getChainValue("max_withdrawal", selectedNetwork)) ??
    null;

  const getReceiveAmount = () => {
    const amount = parseFloat(withdrawAmount) || 0;
    const fee = getSelectedNetworkFee();
    const receive = amount - fee;
    return receive > 0 ? receive : 0;
  };

  const handleWithdrawAmountChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setWithdrawAmount(value);
    }
  };

  const parsedWithdrawAmount = parseFloat(withdrawAmount) || 0;
  const parsedAvailableBalance = parseFloat(availableBalance) || 0;
  const minWithdrawalLimit = getSelectedNetworkMinWithdrawal();
  const showInsufficientFunds =
    withdrawAmount !== "" && parsedWithdrawAmount > parsedAvailableBalance;
  const showMinWithdrawalError =
    selectedNetwork &&
    minWithdrawalLimit > 0 &&
    withdrawAmount !== "" &&
    parsedWithdrawAmount > 0 &&
    parsedWithdrawAmount < minWithdrawalLimit;

  const fetchWithdrawalAssetChain = async (asset, depositCoinItem) => {
    if (!asset) return;
    const requestId = ++fetchChainRequestRef.current;
    const activeChains = filterActiveCoboChains(depositCoinItem?.cobo_chain_list);
    setLoadingAssetChain(true);
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.checkCoboWithdrawalAssetChain(asset);
      if (requestId !== fetchChainRequestRef.current) return;

      if (result?.success && result?.data) {
        const withdrawChainMap = {};
        (result.data?.cobo_chain_list || []).forEach((chain) => {
          if (chain?.chainId) withdrawChainMap[chain.chainId] = chain;
        });
        setSelectedCurrency({
          ...depositCoinItem,
          ...result.data,
          cobo_chain_list: activeChains.map((chain) => ({
            ...(withdrawChainMap[chain.chainId] || {}),
            ...chain,
          })),
        });
      } else {
        setSelectedCurrency({
          ...depositCoinItem,
          cobo_chain_list: activeChains,
        });
        alertErrorMessage(result?.message || "Failed to load withdrawal limits");
      }
    } catch (error) {
      if (requestId === fetchChainRequestRef.current) {
        setSelectedCurrency({
          ...depositCoinItem,
          cobo_chain_list: activeChains,
        });
        alertErrorMessage("Failed to load withdrawal limits");
      }
    } finally {
      if (requestId === fetchChainRequestRef.current) {
        setLoadingAssetChain(false);
        LoaderHelper.loaderStatus(false);
      }
    }
  };

  const handleSelectDepositCoin = async (item) => {
    if (fundData?.length === 0) {
      const fundData = await handleUserFunds();
      if (!fundData) {
        alertErrorMessage("Some error occured. Please try again later.")
        return;
      }
    }
    const depositCoinItem = {
      ...item,
      cobo_chain_list: filterActiveCoboChains(item?.cobo_chain_list),
    };
    setSelectedCurrency(depositCoinItem);
    setSelectedNetwork("");
    setSelectedNetworkInfo(null);
    setWithdrawAmount("");
    setWithdrawAddress("");
    $("#search_coin").modal('hide');
    await fetchWithdrawalAssetChain(item?.short_name, depositCoinItem);
  };

  const handleSelectNetwork = (network) => {
    if (!isCoboChainActive(network)) return;
    const chainId = network?.chainId || network;
    setSelectedNetwork(chainId);
    setSelectedNetworkInfo(typeof network === "object" ? network : null);
    setWithdrawAddress("");
    setIsValidWalletAddress(true);
    $("#network_pop_up").modal('hide');
  };

  const handleMaxWithdrawal = () => {
    const balance = parseFloat(availableBalance) || 0;
    const maxLimit = getSelectedNetworkMaxWithdrawal();
    const amount = maxLimit != null && maxLimit > 0 ? Math.min(balance, maxLimit) : balance;
    setWithdrawAmount(amount > 0 ? amount : "");
  };


  const handleUserFunds = async () => {
    try {
      LoaderHelper.loaderStatus(true)
      const result = await AuthService.getUserfunds("main")
      if (result?.success) {
        setFundData(result?.data);
        return true
      }
    } catch (error) {
    } finally { LoaderHelper.loaderStatus(false) }

  };

  const handleWithdrawalAddress = (e) => {
    const address = e.target.value;
    setWithdrawAddress(address);
    let isValid = false;
    let regexPattern = /^$/;

    if (selectedNetwork === "TRON") {
      regexPattern = /^T[a-zA-Z0-9]{33}$/;
    } else if (selectedNetwork === "BTC") {
      regexPattern = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;
    } else {
      regexPattern = /^0x[a-fA-F0-9]{40}$/;
    }



    isValid = regexPattern.test(address);

    if (!isValid && address.length > 0) {
      setIsValidWalletAddress(false)
    } else {
      setIsValidWalletAddress(true)
    }
  }

  const handleAuthCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setotp(value);
  };

  const handleResetInput = () => {
    setSelectedCurrency({});
    setWithdrawAddress("");
    setWithdrawAmount("");
    setotp("");
    setSelectedNetwork("");
    setSelectedNetworkInfo(null);
  };

  const [, setAnnouncments] = useState([]);
  const handleNotifications = async () => {
    await AuthService.notifications().then(async (result) => {
      if (result?.data?.length > 0) {
        try {
          let announcement = result?.data?.filter((item) => item?.type === "announcement")
          if (announcement?.length === 1) {
            setAnnouncments([...announcement, ...announcement]);
          } else if (announcement?.length > 1) {
            setAnnouncments(announcement?.reverse());
          }

        } catch (error) {

        }
      }
    });
  };


  const handleWithdrawCurrency = async () => {
    if (isWithdrawalDisabled) return;
    const fee = getSelectedNetworkFee();
    const amount = parseFloat(withdrawAmount) || 0;
    const receiveAmount = getReceiveAmount();
    const maxLimit = getSelectedNetworkMaxWithdrawal();
    const minLimit = getSelectedNetworkMinWithdrawal();
    const authCode = String(otp || "").trim();
    if (
      Object.keys(selectedCurrency).length <= 0 ||
      !withdrawAddress ||
      !selectedNetwork ||
      parsedAvailableBalance < fee ||
      amount > parsedAvailableBalance ||
      !amount ||
      !authCode ||
      !isValidWalletAddress ||
      receiveAmount <= 0 ||
      (minLimit > 0 && amount < minLimit) ||
      (maxLimit != null && maxLimit > 0 && amount > maxLimit)
    ) {
      if (!authCode) alertErrorMessage("Authentication code is required");
      else if (!withdrawAddress || !isValidWalletAddress) alertErrorMessage("Please enter a valid withdrawal address");
      else if (showInsufficientFunds) alertErrorMessage("Insufficient funds");
      else if (showMinWithdrawalError) alertErrorMessage(`Minimum withdrawal limit is ${minLimit} ${selectedCurrency?.short_name}`);
      return;
    }

    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.createCoboWithdrawalRequest({
        amount: amount,
        address: withdrawAddress,
        chainId: selectedNetworkInfo?.chainId || selectedNetwork,
        coin: selectedCurrency?.short_name,
        otp: authCode,
      });
      if (result?.success) {
        setWithdrawSuccessData({
          coin: selectedCurrency?.short_name,
          amount: receiveAmount,
          withdrawAmount: amount,
          fee,
          address: withdrawAddress,
          chainId: selectedNetworkInfo?.chainId || selectedNetwork,
          network: getNetworkLabel(),
          message: result?.message || "Withdrawal request created successfully.",
        });
        handleResetInput();
        handleUserFunds();
        withdrawHistory();
        $("#withdraw_success_modal").modal("show");
      } else {
        alertErrorMessage(result?.message || "Failed to create withdrawal request");
      }
    } catch (error) {
      alertErrorMessage("Failed to create withdrawal request");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const copytext = (data) => {
    navigator.clipboard.writeText(data);
    alertSuccessMessage("Copied!!");
  };

  useEffect(() => {
    if (searchPair) {
      const q = searchPair.toLowerCase();
      const filteredPair = allData?.filter((item) =>
        item?.short_name?.toLowerCase()?.includes(q) ||
        item?.name?.toLowerCase()?.includes(q)
      );
      setAvailableCurrency(filteredPair);
    } else {
      setAvailableCurrency(allData);
    }
  }, [searchPair, allData]);



  useEffect(() => {
    if (fundData?.length > 0 && Object.keys(selectedCurrency).length > 0) {
      let filteredData = fundData?.filter((item) => item?.currency_id === selectedCurrency?._id)[0]
      if (Object.keys(filteredData).length > 0) {
        setAvailableBalance(filteredData?.balance)
      }
    }

  }, [fundData, selectedCurrency]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    getCoboDepositAssets();
    handleNotifications();
    withdrawHistory()
    allCoins()

  }, []);



  return (
    <>
  
      <div className="dashboard_right">

        <div className="deposit_crypto_block_coin">

          <div className="deposit_crypto_left withdrawal_outer">


            <div className={`select_coin_option ${Object.keys(selectedCurrency).length > 0 && "select-option"}`}>

              <h2>Select Coin</h2>

              <div className="search_icon_s" data-bs-toggle="modal" data-bs-target="#search_coin">
                <img src="/images/search_icon.svg" alt="search" /> {Object.keys(selectedCurrency).length > 0 ? `${selectedCurrency?.short_name} ${selectedCurrency?.name} ` : "Search Coin"}
              </div>



              {/* <!-- Modal Search Coin Start --> */}

              <div className="modal fade search_form search_coin search_form_modal_2" id="search_coin" tabIndex="-1" aria-labelledby="exampleModalLabel" >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5>Select Crypto</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <form>
                        <input type="text" className="search" placeholder="Search coin name" value={searchPair} onChange={(e) => setSearchPair(e.target.value)} />
                      </form>

                      <div className="hot_trading_t">



                        <table>
                          <tbody>
                            {availableCurrency?.length > 0 ? availableCurrency?.map((item) => {
                              return (
                                <tr onClick={() => handleSelectDepositCoin(item)} data-bs-dismiss="modal" >
                                  <td>
                                    <div className="td_first">
                                      <div className="icon"><img src={ApiConfig?.baseImage + item?.icon_path} alt="icon" width="30px" /></div>
                                      <div className="price_heading"> {item?.short_name} <br /> </div>
                                    </div>
                                  </td>
                                  <td className="right_t price_tb">{item?.name}</td>
                                </tr>
                              )
                            }) : ""}




                          </tbody>
                        </table>

                      </div>


                    </div>

                  </div>
                </div>
              </div>


              {/* <!-- Modal Search Coin Start End --> */}



              <div className="coin_items_select">
                {allData?.slice(0, 4)?.map((item) => {
                  return (
                    <div className="coin_items_list" onClick={() => handleSelectDepositCoin(item)} >
                      <img src={ApiConfig?.baseImage + item?.icon_path} alt="icon" />{item?.short_name}
                    </div>
                  )
                })}


              </div>

            </div>




            <div className={`select_network_s ${(selectedNetwork && withdrawAddress && isValidWalletAddress) && "select-option"}`}>

              <h2>Withdraw to</h2>
              {Object.keys(selectedCurrency).length > 0 ? <div className="search_icon_s" data-bs-toggle="modal" data-bs-target="#network_pop_up">{getNetworkLabel()}</div> : <div className="search_icon_s" >{getNetworkLabel()}</div>}




              <div className="address_input ">
                <input type="text" placeholder="Enter Address" onChange={handleWithdrawalAddress} value={withdrawAddress} disabled={!selectedNetwork} />
                <div className="icon_cnt">
                  <svg className="bn-svg icon-normal-pointer text-IconNormal" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.25 4.41h-3v3h3v-3zM6.25 10.41h-3v3h3v-3zM6.25 16.41h-3v3h3v-3z" fill="currentColor"></path>
                    <path fillRule="evenodd" clip-rule="evenodd" d="M20.75 20h-12V4h12v16zm-6-8.521a1.872 1.872 0 100-3.745 1.872 1.872 0 000 
      3.745zm-1.338 1.07c-.886 
      0-1.604.718-1.604 1.604v1.605h5.884v-1.605c0-.886-.719-1.605-1.605-1.605h-2.675z" fill="currentColor"></path></svg>
                </div>
                <div className="d-flex items-center top_space opt_cnt">



                </div>
              </div>
              {!isValidWalletAddress && <p className="red"><strong>Invalid wallet address for the selected network!</strong></p>}



              {/* <div className="d-flex items-center justify-content-between top_space">

                <div className="typography-body3">Contract address ending in</div>
                <a href="#">uSpse {">"}</a>

              </div> */}
              {selectedNetwork && <p>The network you selected is {selectedNetwork}, please ensure that the withdrawal address supports the {selectedNetwork} network. You will potentially lose your assets if the chosen plateform does not support
                refunds of wrongfully deposited assets.
              </p>}




              {/* <!-- Modal Network Pop Up Start --> */}

              <div className="modal fade search_form search_coin" id="network_pop_up" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">

                      <div className="network_top_p">
                        <svg className="bn-svg h-m w-m flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clip-rule="evenodd"
                            d="M12 21a9 9 0 100-18 9 9 0 000 18zm-1.25-5.5V18h2.5v-2.5h-2.5zm0-9.5v7h2.5V6h-2.5z" fill="currentColor">
                          </path></svg>
                        <p>Only supported networks on the Zillion Exchange platform are shown. If you provide an address from an unsupported network, your withdrawal request may be rejected. </p>

                      </div>


                      <div className="hot_trading_t">



                        <table>
                          <tbody>
                            {loadingAssetChain ? (
                              <tr>
                                <td colSpan="2" className="text-center py-3">Loading networks...</td>
                              </tr>
                            ) : getCoboNetworks().map((network) => {
                              const legacyKey = getLegacyChainKey(network?.chainId);
                              const minWith = parseNetworkLimit(network?.minWithdrawalLimit) ?? getChainValue('min_withdrawal', network?.chainId) ?? selectedCurrency?.min_withdrawal?.[legacyKey];
                              const maxWith = parseNetworkLimit(network?.maxWithdrawalLimit) ?? getChainValue('max_withdrawal', network?.chainId) ?? selectedCurrency?.max_withdrawal?.[legacyKey];
                              return (
                                <tr key={network?.tokenId || network?.chainId || network?._id} onClick={() => handleSelectNetwork(network)} data-bs-dismiss="modal" >
                                  <td>
                                    <div className="td_first">
                                      <div className="price_heading">
                                        {network?.chainName || network?.chainId}
                                        <br />
                                        <span>{network?.chainId}</span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="right_t price_tb">
                                    {(minWith != null || maxWith != null) && (
                                      <>{minWith ?? "—"} - {maxWith ?? "—"} {selectedCurrency?.short_name}<br /></>
                                    )}
                                    {network?.confirmations != null && (
                                      <><span>{network.confirmations} confirmations</span><br /></>
                                    )}
                                    {network?.requireMemo ? <span>Memo required</span> : <span>≈ 2 mins</span>}
                                  </td>
                                </tr>
                              )
                            })}
                            {!loadingAssetChain && getCoboNetworks().length === 0 && (
                              <tr>
                                <td colSpan="2" className="text-center py-3">No networks available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      </div>


                    </div>

                  </div>
                </div>
              </div>

              {/* <!-- Modal Network Pop Up End --> */}

            </div>





            <div className={`select_network_s  ${parsedWithdrawAmount > 0 && "select-option"}`}>

              <h2>Withdraw amount</h2>

              <div className="withdraw_input">
                <input
                  type="text"
                  inputMode="decimal"
                  onWheel={(e) => e.target.blur()}
                  placeholder={selectedNetwork ? `Minimum ${minWithdrawalLimit} ${selectedCurrency?.short_name || ""}`.trim() : "Enter amount"}
                  disabled={Object.keys(selectedCurrency).length <= 0 || !selectedNetwork}
                  onChange={handleWithdrawAmountChange}
                  value={withdrawAmount}
                />
                <div className="amount_sysmble">
                  {selectedCurrency?.short_name} <span className='max' onClick={handleMaxWithdrawal}>MAX</span>
                </div>
              </div>

              <div className="d-flex items-center top_space opt_cnt">

                {showInsufficientFunds && (
                  <p className="red"><strong>Insufficient funds</strong></p>
                )}
                {showMinWithdrawalError && (
                  <p className="red"><strong>Minimum withdrawal limit is {minWithdrawalLimit} {selectedCurrency?.short_name}</strong></p>
                )}
                {selectedNetwork && getSelectedNetworkMaxWithdrawal() != null && withdrawAmount !== "" && parsedWithdrawAmount > getSelectedNetworkMaxWithdrawal() && (
                  <p className="red"><strong>Amount exceeds maximum withdrawal limit ({getSelectedNetworkMaxWithdrawal()} {selectedCurrency?.short_name})</strong></p>
                )}

              </div>



              <div className="withdraw_amount_cnt">

                <div className="d-flex items-center justify-content-between top_space">

                  <div className="typography-body3">Available Balance</div>
                  <p><strong>{availableBalance} {selectedCurrency?.short_name}</strong></p>

                </div>


                <div className="d-flex items-center justify-content-between top_space">

                  <div className="typography-body3">Withdrawal Fee</div>
                  <p><strong>{selectedNetwork ? getSelectedNetworkFee() : '—'} {selectedCurrency?.short_name}</strong></p>

                </div>
                <div className="d-flex items-center justify-content-between top_space">

                  <div className="typography-body3">Maximum Withdrawal</div>
                  <p><strong>{selectedNetwork && getSelectedNetworkMaxWithdrawal() != null ? getSelectedNetworkMaxWithdrawal() : '—'} {selectedCurrency?.short_name}</strong></p>

                </div>
              </div>


            </div>




            <div className={` select_network_s `}>

              <h2 className={`${String(otp || "").trim() && "active_input"}`}>Google Authenticator code</h2>

              <div className="withdraw_input">
                <input
                  type="text"
                  placeholder="Enter 6-digit code"
                  value={otp}
                  maxLength={6}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleAuthCodeChange}
                  inputMode="numeric"
                  autoComplete="one-time-code"
                />
              </div>


              {/* <div className="d-flex items-center top_space opt_cnt">
                <div className="typography-body3">Available Withdraw</div>
                <p className="red"><strong>9.43657657 USDT</strong></p>

              </div> */}



            </div>


            <div className="total_amount">

              <div className="amount_cnt_l">

                <div className="price_tag_top">
                  Receive amount
                </div>

                <div className="price_tag">
                  {withdrawAmount ? getReceiveAmount() : '---'} {selectedCurrency?.short_name}
                </div>
                <div className="net_fee_t">
                  Network Fee {selectedNetwork ? getSelectedNetworkFee() : '—'} {selectedCurrency?.short_name}
                </div>
              </div>

              <div className="withdraw_btn">
                <button type='button' onClick={handleWithdrawCurrency} disabled={isWithdrawalDisabled}>{isWithdrawalDisabled ? 'Withdrawal Disabled' : 'Withdraw'}</button>
              </div>

            </div>

          </div>



          <div className="deposit_crypto_right">

            <h2>FAQ</h2>

            <div className="accordion accordion-flush" id="accordionFlushExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    How to Withdraw Crypto?
                  </button>
                </h2>
                <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                  <div className="accordion-body">To withdraw crypto, go to the withdrawal section, select your cryptocurrency, enter the recipient wallet address, choose the correct network, and specify the amount. Review the details carefully before confirming the withdrawal. Processing time may vary based on network congestion and withdrawal policies.</div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                    How to Withdraw Crypto Step-by-step Guide
                  </button>
                </h2>
                <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                  <div className="accordion-body"><ul>
                    <li><strong>Go to the Withdrawal Section</strong> – Navigate to the withdrawal page.</li>
                    <li><strong>Select Your Crypto</strong> – Choose the cryptocurrency you want to withdraw.</li>
                    <li><strong>Enter the Wallet Address</strong> – Make sure the address is correct and belongs to the selected blockchain network.</li>
                    <li><strong>Choose the Network</strong> – Select the correct blockchain network (e.g., BEP20, ERC20, TRC20, Polygon).</li>
                    <li><strong>Enter the Amount</strong> – Specify the amount you want to withdraw, ensuring it meets the minimum withdrawal limit.</li>
                    <li><strong>Confirm & Submit</strong> – Review all details carefully and confirm the withdrawal.</li>
                    <li><strong>Wait for Processing</strong> – Withdrawals are processed based on network congestion and request approval.</li>
                  </ul></div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                    Withdrawal hasn't arrived?
                  </button>
                </h2>
                <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                  <div className="accordion-body"><ul>
                    <li><strong>Check Transaction Status</strong> – Use a blockchain explorer to track the transaction.</li>
                    <li><strong>Verify the Wallet Address</strong> – Ensure the recipient address is correct.</li>
                    <li><strong>Confirm Network Selection</strong> – The chosen network should match the recipient's wallet.</li>
                    <li><strong>Check for Pending Processing</strong> – Some withdrawals require manual approval.</li>
                  </ul></div>
                </div>
              </div>
            </div>


          </div>



        </div>





        <div className="recent_deposit_list">


          <div className="top_heading">
            <h4>Recent Withdrawals</h4>
            <a className="more_btn" href="/asset_managemnet/withdraw-history">More &gt;</a>
          </div>

          <div className="table_outer">
            {(() => {
              function shortenAddress(address, length = 4) {
                if (!address || address.length < 10) return address;
                return `${address.slice(0, length + 2)}...${address.slice(-length)}`;
              }
              const CopyIcon = () => (
                <svg className="bn-svg icon-small-pointer" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ width: 18, height: 18, cursor: 'pointer', flexShrink: 0 }}>
                  <path fillRule="evenodd" clipRule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor" />
                </svg>
              );
              const noDataRow = (
                <tr rowSpan="5" className="no-data-row2">
                  <td colSpan="12">
                    <div className="no-data-wrapper">
                      <div className="no_data_vector">
                        <img src="/images/no_data_vector.svg" className="img-fluid dark_img" width="96" height="96" alt="No data" /><img src="/images/no_data_vector_light.png" className="img-fluid light_img" alt="No data"/>
                      </div>
                    </div>
                  </td>
                </tr>
              );
              return (
                <>
                  {/* Desktop: table */}
                  <div className="withdraw_history_desktop">
                    <table>
                      <tbody>
                        {recentWithdrawHistory?.length > 0 ? recentWithdrawHistory?.map((item) => {
                          const shortAddress = shortenAddress(item?.to_address);
                          const shortTxHash = shortenAddress(item?.transaction_hash);
                          const filteredImageData = allCoinData?.filter((data) => data?.short_name === item?.short_name)[0] || [];
                          return (
                            <tr key={item?._id || item?.createdAt}>
                              <td>
                                <div className="td_first">
                                  <div className="price_heading">
                                    <img width="30px" src={Object?.keys(filteredImageData)?.length > 0 ? ApiConfig?.baseImage + filteredImageData?.icon_path : ""} alt="icon" />
                                    {item?.amount} {item?.currency}{' '}
                                    <span className={`text-${item?.status === "REJECTED" ? "danger" : item?.status === "COMPLETED" ? "success" : "warning"}`}>{item?.status}</span>
                                  </div>
                                  <div className="date_info"><span>Date</span>{moment(item.createdAt).format("DD-MM-YYYY  hh:ss A")}</div>
                                </div>
                              </td>
                              <td>Network <span>{item?.chain || item?.chainId || "Internal transfer"}</span></td>
                              <td>Address <div className="address_icon"><span>{shortAddress || "----"}</span>
                                {shortAddress && <span onClick={() => copytext(item?.to_address)}><CopyIcon /></span>}
                              </div></td>
                              <td>TxID <div className="address_icon"><span>{shortTxHash || "----"}</span>
                                {shortTxHash && <span onClick={() => copytext(item?.transaction_hash)}><CopyIcon /></span>}
                              </div></td>
                              <td onClick={() => handleWithdrawModal(item)}>View</td>
                            </tr>
                          );
                        }) : noDataRow}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile: card list */}
                  <div className="withdraw_history_mobile">
                    {recentWithdrawHistory?.length > 0 ? (
                      <div className="withdraw_cards_list">
                        {recentWithdrawHistory?.map((item) => {
                          const shortAddress = shortenAddress(item?.to_address);
                          const shortTxHash = shortenAddress(item?.transaction_hash);
                          const filteredImageData = allCoinData?.filter((data) => data?.short_name === item?.short_name)[0] || [];
                          return (
                            <div key={item?._id || item?.createdAt} className="withdraw_card_item">
                              <div className="withdraw_card_header">
                                <div className="withdraw_card_title">
                                  <img width="32" height="32" src={Object?.keys(filteredImageData)?.length > 0 ? ApiConfig?.baseImage + filteredImageData?.icon_path : ""} alt="" />
                                  <span className="withdraw_amount">{item?.amount} {item?.currency}</span>
                                  <span className={`withdraw_status text-${item?.status === "REJECTED" ? "danger" : item?.status === "COMPLETED" ? "success" : "warning"}`}>{item?.status}</span>
                                </div>
                                <div className="withdraw_card_date">
                                  <span className="label">Date</span> {moment(item.createdAt).format("DD-MM-YYYY  hh:ss A")}
                                </div>
                              </div>
                              <div className="withdraw_card_row">
                                <span className="label">Network</span>
                                <span>{item?.chain || item?.chainId || "Internal transfer"}</span>
                              </div>
                              <div className="withdraw_card_row address_icon">
                                <span className="label">Address</span>
                                <span className="value">{shortAddress || "----"}{shortAddress && <span onClick={() => copytext(item?.to_address)} aria-label="Copy"><CopyIcon /></span>}</span>
                                
                              </div>
                              <div className="withdraw_card_row address_icon">
                                <span className="label">TxID</span>
                                <span className="value">{shortTxHash || "----"}</span>
                                {shortTxHash && <span onClick={() => copytext(item?.transaction_hash)} aria-label="Copy"><CopyIcon /></span>}
                              </div>
                              <div className="withdraw_card_footer">
                                <button type="button" className="withdraw_card_view_btn" onClick={() => handleWithdrawModal(item)}>View</button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="no-data-wrapper">
                        <div className="no_data_vector">
                          <img src="/images/no_data_vector.svg" className="img-fluid dark_img" width="96" height="96" alt="No data" /><img src="/images/no_data_vector_light.png" className="img-fluid light_img" alt="No data"/>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              );
            })()}
          </div>




          {/* <!-- Modal table recent Pop Up Start --> */}

          <div className="modal fade search_form table_pop_up search_form_modal_2" id="recent_table" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h2>Withdrawal Details </h2>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">

                  <div className="withdrawal_top_list">

                    <div className="bn_step_content">
                      <h5>Withdrawal order submitted</h5>
                      <span>{moment(modalData.createdAt).format("DD-MM-YYYY  hh:ss A")}</span>
                    </div>

                    <div className="bn_step_content">
                      <h5>System processing</h5>
                      <span>{moment(modalData.createdAt).format("DD-MM-YYYY  hh:ss A")}</span>
                    </div>

                    <div className="bn_step_content ">
                      <h5 className={modalData?.status === "PENDING" && 'withdrawal_pending'}>{modalData?.status}</h5>
                      <span>{moment(modalData.updatedAt).format("DD-MM-YYYY  hh:ss A")}</span>
                    </div>


                  </div>



                  <div className="hot_trading_t">


                    <table>
                      <tbody>
                        <tr>
                          <td>Status</td>
                          <td className="right_t price_tb">

                            {modalData?.status === "REJECTED" ? <span className="red">{modalData?.status}</span> : modalData?.status === "COMPLETED" ? <span className="green">{modalData?.status} </span> : <span className="yellow">{modalData?.status} </span>}
                          </td>

                        </tr>

                        <tr>
                          <td>Coin</td>
                          <td className="right_t price_tb">{modalData?.short_name}</td>
                        </tr>

                        <tr>
                          <td>Withdraw amount</td>
                          <td className="right_t price_tb">{modalData?.amount}</td>
                        </tr>

                        <tr>
                          <td>Network</td>
                          <td className="right_t price_tb">{modalData?.chain}</td>
                        </tr>

                        <tr>
                          <td>Address</td>
                          <td className="right_t price_tb"><div className="address_icon"><span>{modalData?.shortToAddress || "----"}</span>
                            <svg className="bn-svg icon-small-pointer mobile:icon-normal-pointer mobile:text-IconNormal" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => copytext(modalData?.to_address)}>
                              <path fillRule="evenodd" clip-rule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor"></path></svg></div></td>
                        </tr>

                        <tr>
                          <td>TxID</td>
                          <td className="right_t price_tb"><div className="address_icon"><span>{modalData?.shortTxHash?.trim() || "----"}</span>
                            <svg className="bn-svg icon-small-pointer mobile:icon-normal-pointer mobile:text-IconNormal" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => copytext(modalData?.transaction_hash)}>
                              <path fillRule="evenodd" clip-rule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor"></path></svg></div></td>
                        </tr>





                      </tbody>
                    </table>

                    {/* <p className="help_chat"><a href="/user_profile/support">Help? Chat with us</a></p> */}

                  </div>


                </div>

              </div>
            </div>
          </div>


          {/* <!-- Modal  table recent Pop Up End --> */}

          <div className="modal fade search_form table_pop_up search_form_modal_2" id="withdraw_success_modal" tabIndex="-1" aria-labelledby="withdrawSuccessLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h2>Withdrawal Request Submitted</h2>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  {withdrawSuccessData && (
                    <>
                      <p className="green mb-3"><strong>{withdrawSuccessData.message}</strong></p>
                      <div className="hot_trading_t">
                        <table>
                          <tbody>
                            <tr>
                              <td>Coin</td>
                              <td className="right_t price_tb">{withdrawSuccessData.coin}</td>
                            </tr>
                            <tr>
                              <td>Network</td>
                              <td className="right_t price_tb">{withdrawSuccessData.network}</td>
                            </tr>
                            <tr>
                              <td>Withdraw Amount</td>
                              <td className="right_t price_tb">{withdrawSuccessData.withdrawAmount} {withdrawSuccessData.coin}</td>
                            </tr>
                            <tr>
                              <td>Withdrawal Fee</td>
                              <td className="right_t price_tb">{withdrawSuccessData.fee} {withdrawSuccessData.coin}</td>
                            </tr>
                            <tr>
                              <td>Receive Amount</td>
                              <td className="right_t price_tb"><span className="green">{withdrawSuccessData.amount} {withdrawSuccessData.coin}</span></td>
                            </tr>
                            <tr>
                              <td>Address</td>
                              <td className="right_t price_tb">
                                <div className="address_icon">
                                  <span>{withdrawSuccessData.address}</span>
                                  <svg className="bn-svg icon-small-pointer" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => copytext(withdrawSuccessData.address)}>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor"></path>
                                  </svg>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Chain ID</td>
                              <td className="right_t price_tb">{withdrawSuccessData.chainId}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>


        </div>




      </div>


    </>
  )
}

export default WithdrawPage
